// This workaround fixes crashes related to browser extensions
// that modify the DOM (e.g. Google Translate).

import { isEnglishLang } from "@app/analytics/utils/langUtils";

const applyFixIfNeeded = () => {
  if (isEnglishLang()) {
    // add no translate to the html tag
    document.querySelector("html")?.setAttribute("translate", "no");
    return false;
  }

  if (typeof Node === "function" && Node.prototype) {
    const originalRemoveChild = Node.prototype.removeChild;
    Node.prototype.removeChild = function <T extends Node>(child: T): T {
      if (child.parentNode !== this) {
        if (console) {
          console.error(
            "Cannot remove a child from a different parent",
            child,
            this
          );
        }
        return child;
      }
      return originalRemoveChild.apply(this, arguments as any) as T;
    };

    const originalInsertBefore = Node.prototype.insertBefore;
    Node.prototype.insertBefore = function <T extends Node>(
      newNode: T,
      referenceNode: Node | null
    ): T {
      if (referenceNode && referenceNode.parentNode !== this) {
        if (console) {
          console.error(
            "Cannot insert before a reference node from a different parent",
            referenceNode,
            this
          );
        }
        return newNode;
      }
      return originalInsertBefore.apply(this, arguments as any) as T;
    };
  }

  return true;
};

export default applyFixIfNeeded;
